// トグル(アコーディオン)表示
import commonClass from "./commonClass";

export default class toggleClass extends commonClass {
  // コンストラクタ
  constructor() {
    super();
    this._getSuper();
    this._classValiableDefine();

    this._init();
  }

  // 親classから変数を取得してくる
  _getSuper() {
  }
  // class変数定義
  _classValiableDefine() {
    this._prt = '.js-tgl';
    this._trg = '.js-tgl_trg';
    this._tgt = '.js-tgl_tgt';
  }


  // 初期化用関数
  _init() {
    this._main();
  }

  // リサイズ用関数
  _resize() {
  }

  // メイン処理
  _main() {
    var cls = this;

    $(cls._prt).each(function(index, el) {
      var $self = $(el);

      if ($self.hasClass('is-open')) {
        $self.find(cls._tgt).eq(0).css('display', 'block');
      }
    });

    $(document).on('click', cls._trg, function() {
      var $this = $(this);
      var $prt = $this.closest(cls._prt);
      var $tgt = $prt.find(cls._tgt).eq(0);

      $tgt.stop().slideToggle();
      $prt.toggleClass('is-close is-open');

      // アコーディオン内にDataTableが存在するときに強制的にリサイズを行う
      if ($tgt.find('table.dataTable').length) {
        $tgt.resize();
      }

      return false;
    });
  }

}